import type { TranslationDict } from '../en';

const sl: TranslationDict = {
  'header.buy': 'Kupi',
  'header.sell': 'Prodaj',
  'spend.label': 'Porabite',
  'spend.placeholderFiat': '250',
  'spend.placeholderCrypto': '0.01',
  'receive.label': 'Prejmete',
  'payment.label': 'Način plačila',
  'payment.select': 'Izberi',
  'provider.label': 'By',
  'provider.select': 'Select',
  'provider.unavailable': 'Unavailable',
  'provider.unavailablePayment': 'Payment method not supported',
  'provider.unavailableCountry': 'Region not supported',
  'provider.unavailableCurrency': 'Currency not supported',
  'provider.unavailableNetwork': 'Network not supported',
  'payment.noneAvailable': 'Za ta par ni na voljo nobene metode plačila',
  'wallet.label': 'Naslov prejemne denarnice',
  'wallet.placeholderBuy': 'Vnesite naslov za prejem',
  'wallet.placeholderSell': 'Vnesite naslov za pošiljanje',
  'wallet.validating': 'Preverjanje naslova...',
  'wallet.invalid': 'Vnesite veljaven naslov denarnice',
  'wallet.invalidServer': 'Neveljaven naslov denarnice',
  'cta.buy': 'Kupi {crypto}',
  'cta.sell': 'Prodaj {crypto}',
  'cta.gettingPrice': 'Iščemo najboljšo ceno...',
  'cta.processing': 'Obdelava...',
  'footer.poweredBy': 'Poganja ',
  'footer.brand': 'NowRamp',
  'rate.title': 'Razčlenitev tečaja',
  'rate.close': 'Zapri',
  'rate.updatesIn': 'Tečaj se posodobi čez 00:{seconds}',
  'rate.noQuote': 'Ponudba ni na voljo',
  'rate.exchangeRate': 'Menjalni tečaj',
  'rate.processingFee': 'Provizija za obdelavo',
  'rate.networkFee': 'Omrežna provizija',
  'rate.provider': 'Ponudnik',
  'toast.orderCreated': 'Naročilo ustvarjeno',
  'toast.redirecting': 'Preusmeritev na plačilo...',
  'toast.orderFailed': 'Naročilo ni uspelo',
  'toast.couldNotCreate': 'Naročila ni bilo mogoče ustvariti',
  'toast.quoteError': 'Napaka ponudbe',
  'toast.noProviders': 'Ni ponudnikov',
  'toast.somethingWrong': 'Prišlo je do napake',
  'error.amountZero': 'Znesek mora biti večji od 0',
  'error.minAmountFiat': 'Minimalni znesek je {min} {currency}',
  'error.minAmountCrypto': 'Minimalni znesek je {min} {currency}',
  'error.noProviders': 'Za to kombinacijo ni na voljo nobenega ponudnika',
  'error.currencyUnavailableBuy': 'Ta valuta ni na voljo za nakupna naročila',
  'error.currencyUnavailableSell': 'Ta valuta ni na voljo za prodajna naročila',
  'parity.info': 'Zaračunano vam bo za {receiveAmount} {crypto}, preostanek do {spendAmount} {fiat} bo dobropisano na vaš račun {partner}',
  'redirect.secureBadge': 'Varno plačilo',
  'redirect.title': 'Nadaljuj s plačilom',
  'redirect.description': 'Preusmerjeni boste na {gateway}, kjer boste dokončali plačilo.',
  'redirect.countdown': 'Preusmeritev čez {seconds}...',
  'redirect.openTab': 'Odpri ACH v novem zavihku',
  'redirect.cancel': 'Prekliči',
  'checkout.noOrder': 'Naročilo ni bilo najdeno',
  'checkout.goBack': 'Nazaj',
  'checkout.expired': 'Seja za plačilo je potekla',
  'checkout.expiredDesc': 'Seja je potekla. Prosimo, poskusite znova.',
  'checkout.startOver': 'Začni znova',
  'checkout.cancel': 'Prekliči',
  'checkout.loading': 'Nalaganje plačila...',
  'checkout.iframeTitle': 'Plačilo ponudnika',
  'checkout.widgetTitle': 'Plačilna blagajna',
  'checkout.unknownMethod': 'Neznan način plačila',
  'processing.default': 'Obdelava vašega naročila...',
  'processing.pending': 'Čakanje na potrditev plačila...',
  'processing.active': 'Obdelava vaše transakcije...',
  'processing.generic': 'Obdelava...',
  'processing.checkingStatus': 'Preverjanje stanja...',
  'processing.orderId': 'ID naročila',
  'processing.provider': 'Ponudnik',
  'processing.amount': 'Znesek',
  'processing.receiving': 'Prejem',
  'processing.network': 'Omrežje',
  'processing.toAddress': 'Na naslov',
  'processing.usuallyMinutes': 'To običajno traja nekaj minut.',
  'processing.safeToClose': 'To stran lahko varno zaprete — ko bo dokončano, vam bomo poslali e-pošto.',
  'complete.buyTitle': 'Nakup dokončan!',
  'complete.sellTitle': 'Prodaja dokončana!',
  'complete.buyDesc': 'Vaš {crypto} je bil poslan v vašo denarnico.',
  'complete.sellDesc': 'Vaše izplačilo v {fiat} se obdeluje.',
  'complete.amountBuy': 'Prejeti znesek',
  'complete.amountSell': 'Prodani znesek',
  'complete.paidBuy': 'Plačani znesek',
  'complete.paidSell': 'Znesek izplačila',
  'complete.network': 'Omrežje',
  'complete.wallet': 'Denarnica',
  'complete.transaction': 'Transakcija',
  'complete.provider': 'Ponudnik',
  'complete.orderId': 'ID naročila',
  'complete.completed': 'Dokončano',
  'complete.viewExplorer': 'Ogled v Explorerju',
  'complete.done': 'Končano',
  'errorStep.failed': 'Plačilo ni uspelo',
  'errorStep.cancelled': 'Naročilo preklicano',
  'errorStep.expired': 'Naročilo je poteklo',
  'errorStep.refunded': 'Naročilo vrnjeno',
  'errorStep.unknown': 'Prišlo je do napake',
  'errorStep.failedBuy': 'Vašega plačila ni bilo mogoče obdelati. Prosimo, poskusite znova ali uporabite drug način plačila.',
  'errorStep.failedSell': 'Vaše prodaje ni bilo mogoče obdelati. Prosimo, poskusite znova.',
  'errorStep.cancelledBuy': 'Vaše naročilo je bilo preklicano. Nobeno plačilo ni bilo obdelano.',
  'errorStep.cancelledSell': 'Vaša prodaja je bila preklicana. Noben kripto ni bil prenesen.',
  'errorStep.expiredBuy': 'Vaše naročilo je poteklo. Prosimo, začnite nov nakup.',
  'errorStep.expiredSell': 'Vaše naročilo je poteklo. Prosimo, začnite novo prodajo.',
  'errorStep.refundedBuy': 'Vaše plačilo je bilo vrnjeno. Sredstva bi se morala pojaviti na vašem računu v 5–10 delovnih dneh.',
  'errorStep.refundedSell': 'Vaš kripto je bil vrnjen. Sredstva bi se morala kmalu pojaviti v vaši denarnici.',
  'errorStep.genericDesc': 'Prišlo je do nepričakovane napake. Prosimo, poskusite znova.',
  'errorStep.orderId': 'ID naročila',
  'errorStep.tryAgain': 'Poskusi znova',
  'errorStep.startOver': 'Začni znova',
  'errorStep.return': 'Nazaj',
  'errorStep.needHelp': 'Potrebujete pomoč? Kontaktirajte ',
  'errorStep.reference': 'Referenca: {orderId}',
  'confirm.buyTitle': 'Potrdi nakup',
  'confirm.sellTitle': 'Potrdi prodajo',
  'confirm.loading': 'Nalaganje...',
  'confirm.provider': 'Ponudnik',
  'confirm.youPay': 'Plačate',
  'confirm.youSell': 'Prodajate',
  'confirm.youReceive': 'Prejmete',
  'confirm.wallet': 'Denarnica',
  'confirm.network': 'Omrežje',
  'confirm.refundAddress': 'Naslov za vračilo',
  'confirm.parityNote': 'Zaračunani znesek ponudnika se lahko razlikuje. Preostanek do {amount} {crypto} bo dobropisano na vaš račun {partner}.',
  'confirm.processing': 'Obdelava...',
  'confirm.confirmPay': 'Potrdi in plačaj',
  'confirm.confirmSell': 'Potrdi in prodaj',
  'confirm.payout': 'Izplačilo v {currency}',
  'modal.selectFiat': 'Izberite valuto fiat',
  'modal.selectCrypto': 'Izberite kriptovaluto',
  'modal.choosePayment': 'Izberite način plačila',
  'modal.selectCountry': 'Izberite svojo državo',
  'modal.selectLanguage': 'Select language',
  'modal.popular': 'Priljubljeno',
  'modal.recommended': 'Priporočeno',
  'modal.noCurrencies': 'Nobena valuta ni bila najdena',
  'modal.noPaymentMethods': 'Noben način plačila ni bil najden',
  'modal.noCountries': 'Nobena država ni bila najdena',
  'modal.noLanguages': 'No languages found',
  'settings.location': 'Lokacija',
  'settings.darkMode': 'Temni način',
  'settings.privacy': 'Politika zasebnosti',
  'settings.terms': 'Pogoji uporabe',
  'settings.language': 'Jezik',
  // ─── Additional ───
  'modal.chooseRamp': 'Izberite Ramp',
  'modal.bestPrice': 'Najboljša cena',
  'modal.noQuotes': 'Za to zahtevo ni na voljo nobene ponudbe',
  'modal.noProvidersFound': 'Noben ponudnik ni bil najden',
  'payment.unavailableFor': 'Za {currency} ni na voljo nobene metode plačila',
  'skeleton.poweredBy': 'Powered by NowRamp',
  'error.createOrderFailed': 'Ustvarjanje naročila ni uspelo',
  'errorStep.returnToMerchant': 'Nazaj k trgovcu',
  'confirm.cryptoOnNetwork': '{crypto} na {network}',
  'payment.name.card': 'Kartica',
  'payment.name.bankTransfer': 'Bančni Prenos',
  'payment.name.ach': 'ACH',
  'rate.updatesInLabel': 'Rate updates in',
  'rate.networkFeeIncl': 'Network fee incl.',
  'rate.rateTooltip': 'As the market is highly volatile, we can fix the exchange rate for no longer than 30 seconds.',
  'rate.networkFeeTooltip': 'Includes a fee charged by blockchain to execute the transaction.',
  'rate.feeIncluded': '{percentage}% incl.',
  'receive.fetchingRate': 'Fetching best rate...',
  'redirect.tabHelper': 'If the new tab has not opened, click the button above.',
};

export default sl;
